import React from "react";
import { defineMessages } from "react-intl";
import { FormSelectValueField } from "cci-component";

const messages = defineMessages({
  status: {
    id: "status",
    defaultMessage: "Status"
  },

  active: {
    id: "active",
    defaultMessage: "Active"
  },

  inactive: {
    id: "inactive",
    defaultMessage: "Inactive"
  },
});

/**
 * General status select field which allows the user to select the "active" or "inactive" status.
 */
const FormGeneralStatusField = props => (
  <FormSelectValueField options={[messages.active, messages.inactive]} name="status" label={messages.status} {...props}/>
);

export default FormGeneralStatusField;
